import { EntityServiceName } from '../enums/enums';
import { SimulationState } from '../entities/replancity_RunnedAlgorithm';
import type * as schema from '../schema';

export type CopyMode = 'ONLY_STOPS' | 'FULL_COPY';

export type Run = {
    id: string;
    title: string;
    state?: SimulationState;
} & schema.definitions['entities_replancity_RunTask'];

export const RunEntityName = 'replancity_RunTask';

export type PresetEntityName =
    | 'replancity_PublicTransitPreset'
    | 'replancity_RoadInfrastructurePreset'
    | 'replancity_MaasPreset'
    | 'replancity_EvPreset'
    | 'replancity_ScenarioCasePreset';

export type PresetTypeKey =
    | 'roadInfrastructurePreset'
    | 'publicTransitPreset'
    | 'maasPreset'
    | 'evPreset'
    | 'scenarioCasePreset';

export const PRESET_BY_ENTITY_NAME_KEY: Record<PresetEntityName, PresetTypeKey> = {
    replancity_RoadInfrastructurePreset: 'roadInfrastructurePreset',
    replancity_PublicTransitPreset: 'publicTransitPreset',
    replancity_MaasPreset: 'maasPreset',
    replancity_EvPreset: 'evPreset',
    replancity_ScenarioCasePreset: 'scenarioCasePreset',
};

export const PRESET_ENTITY_NAME_BY_PRESET_TYPE_KEY: Record<PresetTypeKey, PresetEntityName> = {
    roadInfrastructurePreset: 'replancity_RoadInfrastructurePreset',
    publicTransitPreset: 'replancity_PublicTransitPreset',
    maasPreset: 'replancity_MaasPreset',
    evPreset: 'replancity_EvPreset',
    scenarioCasePreset: 'replancity_ScenarioCasePreset',
};

export type CreationPresetMetadataName =
    | 'replancity_RoadPresetCreateRequest'
    | 'replancity_TransitPresetCreateRequest'
    | 'replancity_ElectricPresetCreateRequest';

export type CreationPreset = {
    metaDataName: CreationPresetMetadataName;
    presetName: PresetEntityName;
    printedName: string;
};

export type GetPresetsTransit = {
    serviceName: Extract<EntityServiceName, EntityServiceName.PUBLIC_TRANSIT>;
    data: { sourcePresetId: string; presetName: string; copyMode: CopyMode };
};

export type GetPresetsRoadsAndMaas = {
    serviceName: Exclude<EntityServiceName, EntityServiceName.PUBLIC_TRANSIT>;
    data: { sourcePresetId: string; presetName: string };
};

export type GetPresetsEv = {
    data: { percentageOfElectricVehicles: string };
};

export type CopyPresetFnArgs = (GetPresetsTransit | GetPresetsRoadsAndMaas) & {
    abortSignal: AbortSignal;
};

export type TraceRoutesToNetworkData = { roadPresetId: string; transitPresetId: string };

export type TraceLineToNetworkData = { transitLineId: string; roadPresetId: string };

export type TraceRouteToNetworkData = { transitRouteId: string; roadPresetId: string };

export type TraceRoutesToNetwork = {
    serviceName: Extract<EntityServiceName, EntityServiceName.PUBLIC_TRANSIT>;
    data: TraceRoutesToNetworkData;
};

export type TraceLineToNetwork = {
    serviceName: Extract<EntityServiceName, EntityServiceName.PUBLIC_TRANSIT>;
    data: TraceLineToNetworkData;
};

export type TraceRouteToNetwork = {
    serviceName: Extract<EntityServiceName, EntityServiceName.PUBLIC_TRANSIT>;
    data: TraceRouteToNetworkData;
};

export type TraceRoutesToNetworkArgsType = TraceRoutesToNetwork & { abortSignal: AbortSignal };

export type TraceLineToNetworkArgsType = TraceLineToNetwork & { abortSignal: AbortSignal };

export type TraceRouteToNetworkArgsType = TraceRouteToNetwork & { abortSignal: AbortSignal };

export type ProjectPresets = {
    [key in PresetTypeKey]: { id: string; name: string }[];
};

export type SavePresetError = { error: string; details: string };
